var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 256C504 119 393 8 256 8C119 8 8 119 8 256C8 379.78 98.69 482.38 217.25 501V327.69H154.25V256H217.25V201.36C217.25 139.21 254.25 104.88 310.92 104.88C338.06 104.88 366.44 109.72 366.44 109.72V170.72H335.16C304.36 170.72 294.75 189.84 294.75 209.45V256H363.53L352.53 327.69H294.75V501C413.31 482.38 504 379.78 504 256Z",
    fill: "#1778F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.e43285ef48a74e7a9c24989e712d9067.svg";
export { ForwardRef as ReactComponent };